module.exports = __webpack_public_path__ + "img/gmail.b7686b62.png";